<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Login</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card-text>
            <v-form id="loginform"  >
              <v-alert dense text type="error" v-if="authFailed">
                {{authMessage}}
              </v-alert>
              <v-text-field
                v-model="email"
                label="E-mail"
                name="email"
                prepend-icon="person"
                type="email"
                v-validate="'required|email'"
                :error-messages="errors.collect('email')"
                data-vv-name="email"
                required
              ></v-text-field>

              <v-text-field
                v-model="password"
                id="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
                :error-messages="errors.collect('password')"
                data-vv-name="password"
                v-validate="'required'"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click.prevent="register">Sign Up</v-btn>
            <v-btn color="primary" @click.prevent="submit">Login</v-btn>
          </v-card-actions>

          

            
        </v-card>
        <v-divider></v-divider>
        <v-row v-if="codeexist==true">
          <v-col cols="12" md="12" class="text-center mt-2">
              <v-btn color="primary" @click.prevent="guest">Countinue as Guest</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);
export default {
  
 props: {
    source: String
  },
  data: () => ({
    email: '',
    password: '',
    authFailed: false,
    authMessage: "",
    drawer: null,
    code:"",
    codeexist:false,
    dictionary: {
      attributes: {
        email: "E-mail Address"
        // custom attributes
      },
      custom: {},
      usert:[],
    }
  }),
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  computed: {
    isAuthorised() {
      return this.$store.getters.isLoggedin;
    }
    
  },
  created() 
  {
    if (this.$route.params.code) {
      this.code = this.$route.params.code;
      this.codeexist=true;
      console.log("code"+this.code);
    }
    else{
      this.codeexist=false;
    }
    if (Object.keys(this.$user).length !== 0) 
    {
      if (this.$user.userType == "agent") 
      {
        this.$router.push("/agent/dashboard");
      }
        if(this.$user.userType=='business')
        {
          this.$router.push("/businessdashboard");
        }
    } 
    
  },
  methods: {
    guest()
    {
        if(this.code=="")
        {

        }
        else{
          
         this.$router.push({name:'businesshome',params:{code: this.code,key:this.getCookie('jzuserkey')}}); 
        }
    },
    register()
    {
      if(this.code=="")
      {
      this.$router.push("/register");
      }
      else
      {
        
        this.$router.push({name:'bregister',params:{code:  this.code}});
      }
    },
    submit() {
      
      if(this.$validator.validateAll())
      {
        let email = this.email;
        let password = this.password;
          this.$store
            .dispatch("loginuser", { email, password })
            .then(() => {
              if (this.isAuthorised) 
              {
                  console.log('Login');
                  this.authFailed = false;
                  this.authMessage='';

                  let user = JSON.parse(localStorage.getItem("user") || "{}");
                    if (Object.keys(user).length !== 0) 
                    {
                      if (user.userType == "agent") 
                        {
                            this.$router.push("/agent/dashboard");
                        }
                      if(user.userType=='business')
                      {
                        this.$router.push("/businessdashboard");
                      }
                      if(user.userType=='user')
                      {
                        console.log("use");
                        if (this.code!='')
                        {
                        this.$router.push({name:'businesshome',params:{code: this.code}});
                        }else{
                          
                        }

                        //this.$router.push("/businesshome");
                      }
                    } 
              
              }
              else
              {
                this.authFailed = true;
                this.authMessage="User not registered";
                console.log('error');
              }
            })
            .catch(err => {
              console.log('err section');
              this.authFailed = true;
              if (!err.data.success) {
                this.authMessage = err.data.message;
              }
            });
      }
      else{
        
      }
    },
    getCookie(cname) 
    {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }
  }
};
</script>

